import { LitElement, html, css } from 'lit'
import { consume } from '@lit/context'
import { breakpointContext, isSubMenuOpenContext, navigationContext } from '../context.ts'
import { customElement } from 'lit/decorators.js'
import { TW, type Breakpoint, type MenuItem } from '../../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('desktop-navigation')
export class DesktopNavigation extends TwLitElement {

    @consume({context: navigationContext, subscribe: true})
    private _data: MenuItem[] = []

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    @consume({context: isSubMenuOpenContext, subscribe: true})
    private _isSubMenuOpen: boolean = false

    static styles = css`
        :host([hidden]) {
            display: none;
        }
    `

    private _isShown() 
    {
        return this._isSubMenuOpen 
            && [ 'xl', '2xl', '3xl' ].includes( this._breakpoint?.name ?? '' ) // Wann soll die Navigation angezeigt werden?
    }

    render() 
    {
        if ( ! this._isShown() ) {
            this.setAttribute( 'hidden', '' );
            return html``
        }

        this.removeAttribute( 'hidden' );

        // Desktop Navigation: 
        // Das Submenu zeigt ab Level 1 der Navigation an, wenn oben ein MenuItem aktiv ist
        // Falls mehrere MenuItem aktiv sind, wird jede Ebene nebeneinander angezeigt

        const activeItems = this._data.filter( item => item.active ).sort( (a: MenuItem, b: MenuItem) => a.level - b.level )

        // Mindestens ein aktives MenuItem => Wir gehen die aktiven MenuItems durch und zeigen am Ende die Kinder des letzten (tiefsten) aktiven MenuItems

        return html`<div class="container"><nav class="alignwide py-6 flex gap-6" aria-label="Unternavigation">
            ${ activeItems.map( item => {
                const childElements = this._data.filter( child => child.parentId === item.id )
                return html`
                    <ul class="
                        ml-2 border-l border-l-[rgb(187,187,187)] pl-6 
                        first-of-type:border-l-0 first-of-type:pl-0 first-of-type:ml-0
                    ">
                        ${ childElements.map( child => html`
                            <li class="pb-2">
                                <menu-item 
                                    id=${child.id}
                                    class-default=${"font-medium text-neutral-light pb-2 border-b-2 border-transparent hover:text-primary hover:border-b-primary"}
                                    class-active=${"font-medium text-black pb-2 border-b-2 border-transparent"}
                                ></menu-item>
                            </li>
                        ` ) }
                    </ul>
                `
            } ) }
            </ul>
        </nav></div>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'desktop-navigation': DesktopNavigation
    }
}
